import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookingType } from 'src/app/enums/bookingType.enum';
import { BookingSlotType } from 'src/app/models/booking-slot-type';
import { BookingSlot } from 'src/app/models/booking-slot';
import { Doctor } from 'src/app/models/doctor';
import { NgClass, TitleCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomTimePipe } from 'src/app/pipes/custom.timepipe';
import { CustomDatePipe } from 'src/app/pipes/custom.datepipe';
import { TimeAgoPipe } from 'src/app/pipes/time-ago-pipe';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
  standalone: true,
    selector: 'app-appointment-card',
    templateUrl: './appointment-card.component.html',
    styleUrls: ['./appointment-card.component.scss'],
    imports: [NgClass, TitleCasePipe, TranslatePipe, CustomTimePipe, CustomDatePipe, TimeAgoPipe, Button, Tooltip]
})
export class AppointmentCardComponent implements OnInit {

  @Input() toConfirmBookingSlots: BookingSlot[] = [];
  @Input() currentDoctor: Doctor;
  @Input() doctorBookingTypes: BookingSlotType[] = [];

  @Input() totalCount: number = 0;
  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Input() loading: boolean = false;

  @Output() onPageChange = new EventEmitter<number>(); // new output for pagination

  @Output() onConfirm = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();

  bookingTypes = BookingType;

  constructor() { }

  ngOnInit(): void {
  }

  confirmBookingSlot(bookingSlot: any) { 
    this.onConfirm.emit(bookingSlot);
  }

  cancelBookingSlot(bookingSlot: any) {
    this.onCancel.emit(bookingSlot);
  }

  editBookingSlot(bookingSlot: any) {
    this.onEdit.emit(bookingSlot);
  }

  callPatient(bookingSlot: any) {
    if (bookingSlot?.user_phone_number) {
      window.location.href = `tel:${bookingSlot.user_phone_number}`;
    }
  }

  // Helper to get patient initials for avatar
  getPatientInitials(bookingSlot: BookingSlot): string {
    const first = bookingSlot.user_first_name?.charAt(0) || '';
    const last = bookingSlot.user_last_name?.charAt(0) || '';
    return (first + last).toUpperCase();
  }


  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.onPageChange.emit(this.currentPage);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.onPageChange.emit(this.currentPage);
    }
  }

}
